export default __webpack_public_path__ + "static/media/plain-sticker-V.da2bb0e7.png";